export { default } from '@relo/sports-components/es/FormGroupLabel';
export * from '@relo/sports-components/es/FormGroupLabel';
